import { Server } from '../../server/Server';
import View , { registerViewClassProxy, ViewClassProxy } from '../View';
import { IListParams } from '@framework/crud/Crud';

export interface IViewLessonplanRecord {
    /**
     * Azonosító
     *
     * Azonosító (pótkulcs)
     */
    id?: number;
    /**
     * DPMK projekt
     */
    dpmk_project_id?: number;
    /**
     * Intézmény
     */
    institute_id?: number;
    /**
     * Intézmény feladat ellátási hely
     */
    institute_site_id?: number;
    /**
     * Intézmény típus
     */
    institute_type_id?: number;
    /**
     * Műveltségi terület
     */
    literacy_field_id?: number|null;
    /**
     * Tulajdonos/felelős
     */
    owner_id?: number;
    /**
     * Témakör
     */
    topic?: string;
    /**
     * Kereszttantervi kapcsolódás
     */
    cross_curriculum_link?: string|null;
    /**
     * A tanóra célja
     */
    goal?: string;
    /**
     * Fejlesztendő készség
     */
    facility_to_develop?: string;
    /**
     * Pedagógiai módszertan csomag
     */
    dpmk_methodology_package_id?: number|null;
    /**
     * Pedagógiai módszertan csomag
     */
    dpmk_methodology_package_text?: string|null;
    /**
     * Keretek (tanulás szervezési feltételek)
     */
    frame_study_conditions?: string;
    /**
     * Keretek (közreműködő szakemberek)
     */
    frame_contributor_experts?: string|null;
    /**
     * Elsajátítandó fogalmak jegyzéke
     */
    concepts_to_pick?: string;
    /**
     * Megvalósítás tapasztalatai
     */
    conclusions?: string|null;
    /**
     * Javaslatok
     */
    suggestions?: string|null;
    /**
     * A könyv gyökér könyvtára.
     */
    oo_folder_id?: number|null;
    /**
     * Tulajdonos
     *
     * Tulajdonos
     */
    owner_name?: string|null;
    /**
     * Intézmény OM azonosító
     *
     * Intézmény OM azonosító
     */
    institute_om_identifier?: string|null;
    /**
     * Intézmény név
     *
     * Intézmény név
     */
    institute_name?: string|null;
    /**
     * Feladatellátási hely azonosító
     *
     * Feladatellátási hely azonosító
     */
    institute_site_identifier?: string|null;
    /**
     * Feladatellátási hely neve
     *
     * Feladatellátási hely neve
     */
    institute_site_name?: string|null;
    /**
     * Intézmény típus név
     *
     * Intézmény típus név
     */
    institute_type_title?: string|null;
    /**
     * Intézmény típus leírás
     *
     * Intézmény típus leírás
     */
    institute_type_description?: string|null;
    /**
     * Projekt kód
     *
     * Projekt kód
     */
    project_code?: string|null;
    /**
     * Projekt azonoító
     *
     * Projekt azonoító
     */
    project_title?: string|null;
    /**
     * M?veltségi terület
     *
     * M?veltségi terület
     */
    literacy_field_name?: string|null;
    /**
     * Évfolyamok
     *
     * Évfolyamok nevei, vesszővel elválasztva
     */
    grades?: string|null;
    /**
     * Tantárgyak
     *
     * Tantárgyak nevei, vesszővel elválasztva
     */
    subjects?: string|null;
}

/**
 *  doc_pub.view_lessonplan - Óravázlat
 */

export default class ViewLessonplan extends View<IViewLessonplanRecord> {
    public static VIEW_INFO_ID = 2019021901;

    public static getSchemaNameForClass(): string { return 'doc_pub'; }
    public static getViewNameForClass(): string { return 'view_lessonplan'; }
    public static getTableNameForClass(): string|null { return 'lessonplan'; }

    public static canCache(): boolean {
        return true;
    }

    public static load: (id: number, aServer ?: Server) => Promise<ViewLessonplan>;
    public static list: (params: IListParams, aServer ?: Server) => Promise<IViewLessonplanRecord[]>;
}

/**
 * Class for a class proxy object that can emulate virtual class methods.
 */
export class ViewLessonplanClassProxy extends ViewClassProxy<IViewLessonplanRecord> {
}
/**
 * A singleton that emulates virtual classmethods of the corresponding Crud class.
 */
export const viewLessonplanClassProxy = new ViewLessonplanClassProxy(ViewLessonplan);
registerViewClassProxy(viewLessonplanClassProxy);

